import { AfterViewInit,  Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule, DxDataGridModule, DxDropDownBoxComponent, DxDropDownBoxModule } from 'devextreme-angular';
import { Bookmark } from '../models/bookmark.model';
import { BookmarksGroupOperator } from '../operators/bookmarks-group.operator';

import { Subscription } from 'rxjs';

@Component({
    selector: 'app-bookmarks-group-drop-down',
    imports: [
        CommonModule,
        DxDropDownBoxModule,
        DxDataGridModule,
        DxButtonModule,
    ],
    templateUrl: './bookmarks-group-drop-down.component.html',
    styleUrls: ['./bookmarks-group-drop-down.component.scss'],
	standalone: true
})
export class BookmarksGroupDropDownComponent implements OnInit, AfterViewInit {
	
	@ViewChild("dropDownBox", { static: true })
	public dropDownBox: DxDropDownBoxComponent; 
	
	public opened: boolean = false;

	@Output()
	public selectedBookmarkChange: EventEmitter<Bookmark> = new EventEmitter<Bookmark>();

	private _selectedBookmark: Bookmark;
	public get selectedBookmark(): Bookmark {
		return this._selectedBookmark;
	}
	@Input()
	public set selectedBookmark(value: Bookmark) {
		this._selectedBookmark = value;

		this.selectedBookmarkChange.emit(this._selectedBookmark);

		if (this._selectedBookmark){
			this._selectedRowKeys = [this._bookmarksGroupOperator.bookmarks.find((item: Bookmark) => item === this._selectedBookmark).bookmarkId];
		}
	}

	private _selectedRowKeys: number[];
	public get selectedRowKeys(): number[] {
		return this._selectedRowKeys;
	}
	public set selectedRowKeys(value: number[]) {
		this._selectedRowKeys = value;

		if (this._selectedRowKeys.length > 0) {
			this._selectedBookmark = this._bookmarksGroupOperator.bookmarks.find((item: Bookmark) => item.bookmarkId === this._selectedRowKeys[0]);
		}
	}

	private onBookmarkAppliedSubscription: Subscription;

	private _bookmarksGroupOperator: BookmarksGroupOperator;
	public get bookmarksGroupOperator(): BookmarksGroupOperator {
		return this._bookmarksGroupOperator;
	}
	@Input()
	public set bookmarksGroupOperator(value: BookmarksGroupOperator) {
		if (this.onBookmarkAppliedSubscription) {
			this.onBookmarkAppliedSubscription.unsubscribe();
		}

		this._bookmarksGroupOperator = value;

		if (this._bookmarksGroupOperator) {
			this.onBookmarkAppliedSubscription = this._bookmarksGroupOperator.onBookmarkApplied.subscribe(
				{
					next: (bookmark: Bookmark) => {
						

						this.selectedBookmark = bookmark;
						
					}
				}
			);
		}
	}

	// public dataSource: CustomStore = new CustomStore(
	// 	{
	// 		loadMode: 'raw',
	// 		key: 'bookmarkId',
	// 		load: () => {
	// 			console.error(this.bookmarksGroupOperator?.bookmarks);
	// 			return this.bookmarksGroupOperator?.bookmarks;
	// 		},
	// 	}
	// );

	public displayExpr(bookmark: Bookmark) {
		
		return bookmark && `${bookmark.name}`;
	}

	public onOptionChanged(evt: any) {
		if (evt.name === 'value') {
			this.opened = false;
			
			
		}
	}

	constructor(
		// private _changeDetectorRef: ChangeDetectorRef
	) {}

	ngOnInit(): void {
		
	}

	ngAfterViewInit(): void {
		this.dropDownBox.instance.option("dropDownOptions.width", 400);
	}
}